export default __webpack_public_path__ + "static/media/testify10.30994dec.png";